import { render, staticRenderFns } from "./voiceCompose.vue?vue&type=template&id=1248a7ca&scoped=true&"
import script from "./voiceCompose.vue?vue&type=script&lang=js&"
export * from "./voiceCompose.vue?vue&type=script&lang=js&"
import style0 from "./voiceCompose.vue?vue&type=style&index=0&id=1248a7ca&lang=less&scoped=true&"
import style1 from "./voiceCompose.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1248a7ca",
  null
  
)

component.options.__file = "voiceCompose.vue"
export default component.exports